import React from 'react';

import { useStaticAssetPath } from '@zapier/common-components';

import { Upsell } from '@zapier/design-system-revenue/src/components/offers/Upsell';
import { Size } from '@zapier/design-system-revenue/src/types';

import { useData as _useData } from './useData';

type TeamUpsellProps = {
  size: Size;
  /** For dependency injection testing only */
  useData?: () => ReturnType<typeof _useData>;
};

const src = {
  small: '/images/settings/team_upsell.jpg',
  medium: '/images/settings/team_upsell@2x.jpg',
  large: '/images/settings/team_upsell@3x.jpg',
};

export const TeamUpsell = ({ size, useData = _useData }: TeamUpsellProps) => {
  const { accountId } = useData();
  const { buildStaticAssetUrl } = useStaticAssetPath();
  const imageSrc = buildStaticAssetUrl(src[size]);

  return (
    <Upsell
      description="Multiply your productivity. Unlimited users, advanced permissions, and fastest ticket turnaround time. Start your free 14 day trial today."
      imageSrc={imageSrc}
      primaryCta={{
        href: `/app/team-account-setup?context=${accountId}`,
        text: 'Start Trial',
      }}
      secondaryCta={{
        href: '/teams/',
        text: 'Learn More',
      }}
      size={size}
      title="Zapier for Teams"
    />
  );
};
